import React, { useState } from "react";
import Footer from "../components/Footer";
import phd from "../assets/courses/phd.gif";
import { Link } from "react-router-dom";
import { FaUniversity, FaBook, FaChalkboardTeacher, FaGraduationCap, FaRocket, FaGlobe, FaLightbulb } from "react-icons/fa";
import Title from "../components/TitleComponent";

const PHD = () => {
  const [activeTab, setActiveTab] = useState("about");

  const renderContent = () => {
    switch (activeTab) {
      case "about":
        return (
          <div className="grid md:grid-cols-2 gap-10 items-center">
            <Title canonicalPath="/programmes/best-university-for-phd-in-dehradun-uttarakhand" />
            <Title
              title="PhD Programs in Dehradun | Top Colleges and Universities"
              description="Explore PhD programs in Dehradun across various fields. Join top colleges and universities for advanced research opportunities and academic growth in your chosen field.
"
            />
            <div>
              <h1 className="text-3xl md:text-4xl font-bold text-[#0e4d38] mb-6">
                Best University for PhD in Dehradun – Maya Devi University
              </h1>
              <p className="text-gray-700 leading-relaxed text-justify mb-6">
                Are you searching for the <strong>best PhD university in Dehradun</strong>  that blends academic excellence with pioneering research? Look no further than <strong>Maya Devi University</strong> , a prestigious institution committed to shaping the future of scholars across diverse disciplines. Our <strong>Doctor of Philosophy (PhD) programs</strong> are crafted to inspire innovation, analytical thinking, and impactful research contributions.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex items-center gap-3 bg-green-50 p-4 rounded-lg shadow-md">
                  <FaUniversity className="text-[#23376c] text-2xl" />
                  <span className="font-semibold">World-Class Facilities</span>
                </div>
                <div className="flex items-center gap-3 bg-green-50 p-4 rounded-lg shadow-md">
                  <FaChalkboardTeacher className="text-[#23376c] text-2xl" />
                  <span className="font-semibold">Expert Mentorship</span>
                </div>
              </div>
            </div>
            <div>
              <img
                src={phd}
                alt="PhD Program"
                className="w-full rounded-2xl shadow-xl transform hover:scale-105 transition-transform duration-500"
              />
            </div>
          </div>
        );
      case "features":
        return (
          <div className="bg-gray-50 p-8 rounded-2xl shadow-lg">
            <h4 className="text-2xl md:text-3xl font-bold text-[#0e4d38] mb-6">Key Features of Our PhD Programs</h4>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700">
              {[
                "Comprehensive Research Curriculum – Focused on emerging trends and global advancements.",
                "Expert Faculty & Research Mentors – Learn from accomplished academicians and industry specialists.",
                "Advanced Research Facilities – Access high-tech labs, digital libraries, and innovative resources.",
                "Global Networking Opportunities – Engage with international scholars and research institutions.",
                "Flexible Learning Options – Full-time and part-time programs designed for diverse learners.",
                "Affordable Tuition & Scholarships – Ensuring quality education with financial ease.",
                "Research & Publication Support – Guidance for publishing in esteemed journals and academic platforms.",
              ].map((feature, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <FaRocket className="text-[#23376c] text-xl mt-1" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        );
      case "benefits":
        return (
          <div className="bg-gray-50 p-8 rounded-2xl shadow-lg">
            <h4 className="text-2xl md:text-3xl font-bold text-[#0e4d38] mb-6">Top Benefits of Pursuing a PhD at Maya Devi University</h4>
            <ul className="space-y-4 text-gray-700">
              {[
                "Push the Boundaries of Knowledge – Contribute groundbreaking research in your field.",
                "Establish Yourself as an Expert – Gain recognition as a leader in your academic domain.",
                "Lead Independent Research Projects – Develop innovative solutions to real-world problems.",
                "Expand Your Global Network – Collaborate with leading universities and researchers worldwide.",
                "Make a Meaningful Impact – Use research to address societal and industry challenges.",
                "Enhance Career Prospects – Open doors to academia, corporate research, and government roles.",
                "Pursue Teaching & Academic Careers – Become a faculty member at prestigious institutions.",
                "Boost Critical Thinking & Problem-Solving Skills – Develop analytical expertise through research.",
                "Publish & Gain Recognition – Get published in reputed academic journals and conferences.",
                "Achieve Personal & Professional Growth – Embark on a fulfilling journey of intellectual discovery.",
              ].map((benefit, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <span className="text-[#23376c] font-bold">{idx + 1}️⃣</span>
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>
          </div>
        );
      case "why":
        return (
          <div className="bg-gray-50 p-8 rounded-2xl shadow-lg">
            <h4 className="text-2xl md:text-3xl font-bold text-[#0e4d38] mb-6">Why Choose Maya Devi University for Your PhD? </h4>
            <p>At <strong>Maya Devi University</strong> , we are dedicated to fostering a <strong>research-driven academic environment </strong> that addresses real-world challenges. Our PhD programs provide scholars with <strong>expert mentorship, cutting-edge facilities, and strong industry collaborations</strong>  to ensure a holistic research experience. </p>
            <h3 className="text-2xl md:text-3xl font-bold text-[#0e4d38] mt-6 mb-4">Key Features of Our PhD Programs: </h3>
            <ul className="space-y-4 text-gray-700">
              {[
                "Comprehensive Research Curriculum – Focused on emerging trends and global advancements. ",
                "Expert Faculty & Research Mentors – Learn from accomplished academicians and industry specialists. ",
                "Advanced Research Facilities – Access high-tech labs, digital libraries, and innovative resources. ",
                "Global Networking Opportunities – Engage with international scholars and research institutions. ",
                "Flexible Learning Options – Full-time and part-time programs designed for diverse learners. ",
                "Affordable Tuition & Scholarships – Ensuring quality education with financial ease. ",
                "Research & Publication Support – Guidance for publishing in esteemed journals and academic platforms. ",
                // "Inclusive & Collaborative Learning Culture – A community-driven environment promoting growth.",
                // "Recognized for Academic Excellence – A university with a strong reputation in research and education.",
                // "Affordable & Accessible Higher Education – Competitive tuition fees and scholarship options.",
              ].map((reason, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <span className="text-[#23376c] font-bold">{idx + 1}️⃣</span>
                  <span>{reason}</span>
                </li>
              ))}
            </ul>
          </div>
        );
      case "what makes us unique":
        return (
          <div className="bg-gray-50 p-8 rounded-2xl shadow-lg">
            <h4 className="text-2xl md:text-3xl font-bold text-[#0e4d38] mb-6">What Makes Maya Devi University the Best PhD University in Dehradun & Uttarakhand? </h4>
            <ul className="space-y-4 text-gray-700">
              {[
                "Strong Research Foundation – Encouraging scholars to engage in impactful research.",
                "Renowned Faculty & Mentors – Experienced academicians guiding your research journey.",
                "State-of-the-Art Infrastructure – Cutting-edge labs, libraries, and research tools.",
                "Collaborations with Industry & Academia – Partnerships with global research institutions.",
                "Support for Publications & Conferences – Assistance in sharing your work on reputed platforms.",
                "Interdisciplinary Research Approach – Integrating diverse disciplines for innovative solutions.",
                "Comprehensive Career Support – Guidance on academic and corporate career paths.",
                "Inclusive & Collaborative Learning Culture – A community-driven environment promoting growth.",
                "Recognized for Academic Excellence – A university with a strong reputation in research and education.",
                "Affordable & Accessible Higher Education – Competitive tuition fees and scholarship options.",
              ].map((reason, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <span className="text-[#23376c] font-bold">{idx + 1}️⃣</span>
                  <span>{reason}</span>
                </li>
              ))}
            </ul>
          </div>
        );
      case "admission":
        return (
          <div className="bg-gray-50 p-8 rounded-2xl shadow-lg">
            <h4 className="text-2xl md:text-3xl font-bold text-[#0e4d38] mb-6">PhD Admission Process</h4>
            <ol className="space-y-4 text-gray-700 list-decimal list-inside">
              <li>Submit an Online Application through our official portal.</li>
              <li>Appear for the Research Entrance Test (RET) as part of the admission process.</li>
              <li>Participate in an Interview & Proposal Review conducted by our selection panel.</li>
              <li>Enroll and begin your journey with research methodology coursework and foundational studies.</li>
            </ol>
          </div>
        );
      case "disciplines":
        return (
          <div className="bg-gray-50 p-8 rounded-2xl shadow-lg">
            <h4 className="text-2xl md:text-3xl font-bold text-[#0e4d38] mb-6">Explore Our PhD Programs in Diverse Fields</h4>
            <ul className="space-y-3 text-gray-700">
              {["Science & Technology", "Management & Commerce", "Law & Public Policy", "Humanities & Social Sciences", "Healthcare & Life Sciences"].map(
                (field, idx) => (
                  <li key={idx} className="flex items-center gap-3">
                    <FaLightbulb className="text-[#23376c]" />
                    <span>{field}</span>
                  </li>
                )
              )}
            </ul>
          </div>
        );
      case "eligibility":
        return (
          <div className="bg-gray-50 p-8 rounded-2xl shadow-lg">
            <h4 className="text-2xl md:text-3xl font-bold text-[#0e4d38] mb-6">Eligibility Criteria</h4>
            <ul className="space-y-4 text-gray-700">
              <li className="flex items-center gap-3">
                <FaGraduationCap className="text-[#23376c] text-xl" />
                Minimum Master's degree with 55% aggregate marks
              </li>
              <li className="flex items-center gap-3">
                <FaBook className="text-[#23376c] text-xl" />
                Qualifying scores in Maya Devi University Research Entrance Test (NRET)
              </li>
              <li className="flex items-center gap-3">
                <FaChalkboardTeacher className="text-[#23376c] text-xl" />
                NET/GATE/CEED qualified candidates are exempted from NRET
              </li>
            </ul>
          </div>
        );
      case "program":
        return (
          <div className="overflow-x-auto">
            <table className="w-full bg-white shadow-lg rounded-2xl overflow-hidden">
              <thead className="bg-[#23376c] text-white">
                <tr>
                  <th className="p-4 text-left">Programme</th>
                  <th className="p-4 text-left">Duration</th>
                  {/* <th className="p-4 text-left">Entrance Exam Fee</th> */}
                </tr>
              </thead>
              <tbody>
                <tr className="border-b hover:bg-green-50 transition">
                  <td className="p-4 font-semibold">Ph.D Research Program</td>
                  <td className="p-4">Minimum 3 Years</td>
                  {/* <td className="p-4">₹5,000</td> */}
                </tr>
              </tbody>
            </table>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="w-full font-poppins bg-gradient-to-b from-gray-50 to-white mt-20">
      <div className="w-11/12 md:w-10/12 mx-auto pt-20 pb-10 space-y-12">
        <div className="text-center">
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#0e4d38] mb-4 animate-fade-in">
            Doctoral Research Program
          </h2>
          <div className="w-24 mx-auto h-1 bg-[#23376c] rounded-full"></div>
          <p className="mt-4 text-gray-600 text-lg max-w-2xl mx-auto">
            Advance your academic journey with Maya Devi University, the premier destination for PhD studies in Dehradun.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 mb-10">
          {["about", "features", "benefits", "what makes us unique", "why", "admission", "disciplines", "eligibility", "program"].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-6 py-3 rounded-full text-sm md:text-base font-semibold transition-all duration-300 ${activeTab === tab
                ? "bg-[#23376c] text-white shadow-lg"
                : "bg-green-100 text-[#0e4d38] hover:bg-green-200"
                }`}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </button>
          ))}
        </div>

        <div className="bg-white p-6 md:p-10 rounded-2xl shadow-xl transition-all duration-500">
          {renderContent()}
        </div>

        <div className="text-center">
          <Link to="https://admission.maya.edu.in/">
            <button className="bg-[#23376c] px-8 py-4 text-white rounded-full font-semibold text-lg hover:bg-[#4865b3] transition-all duration-300 shadow-md">
              Apply for Ph.D Now
            </button>
          </Link>
          <p className="mt-4 text-gray-600">
            Take the next step with the best PhD university in Dehradun. <strong>Apply today!</strong>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PHD;